import React from 'react'
import FactsData from './factsData.json'
import Grid from './components/Grid'
import Modal from './components/Modal'
import ModalDefault from './components/ModalDefault'
import ModalFact from './components/ModalFact'
import TagMenu from './components/TagMenu'
import Preloader from './components/Preloader';

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentTag: 'all',
      factsData: FactsData.data,
      factsTags: FactsData.tags,
      isEdge: navigator.userAgent.indexOf('Edge') > -1,
      isIE11: navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1,
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      isModalOpen: false,
      isPageLoaded: false,
      modalView: 'default',
      windowWidth: window.innerWidth,
      isProtectQuiz: false
    }

    this.handlers = {
      closeModal: this.closeModal.bind(this),
      getFactsDataByTag: this.getFactsDataByTag.bind(this),
      openModal: this.openModal.bind(this),
      pageLoaded: this.pageLoaded.bind(this),
      startProtectQuiz: this.startProtectQuiz.bind(this),
    }
  }

  componentDidMount() {
    if (!this.state.isIE11) {
      this.eventUpdateGrid = new Event('updateGrid')
    } else {
      this.eventUpdateGrid = document.createEvent('Event')
      this.eventUpdateGrid.initEvent('updateGrid', true, true)
    }
    document.querySelector('html').addEventListener('click', this.closeModal.bind(this))
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' || parseInt(event.key) === 27) {
        if (window.history) {
          window.history.pushState('', '', window.location.origin + window.location.pathname)
        }
        this.setState({
          isModalOpen: false,
          modalView: null
        })
      }
    })
    setTimeout(() => {
      this.setState({
        modalView: this.state.modalView
      })
    }, 800)

    this.getWindowSize()
    window.addEventListener('resize', this.getWindowSize.bind(this))
  }

  componentWillMount() {
    const mobile = /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Windows Phone|Android|iP(ad|od|hone)/i.test(navigator.userAgent)
    if (mobile) {
      document.body.classList.add('mobile')
    }

    if (this.state.isEdge) {
      document.body.classList.add('edge')
    } else if (this.state.isIE11) {
      document.body.classList.add('ie11')
    } else if (this.state.isSafari) {
      document.body.classList.add('safari')
    }
  }

  startProtectQuiz() {
    this.setState({isProtectQuiz: true})
  }

  closeModal(event) {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
      }
      Element.prototype.closest = function(s) {
        var el = this
        var ancestor = this
        if (!document.documentElement.contains(el)) return null
        do {
          if (ancestor.matches(s)) return ancestor
          ancestor = ancestor.parentElement
        } while (ancestor !== null)
        return null
      };
    }

    if ((event.target.closest('.modal-content') === null && event.target.closest('.reload-wrapper') === null) ||
         event.target.classList.contains('icon-close')) {

      window.history.pushState('', '', window.location.origin + window.location.pathname)
      this.setState({
        isModalOpen: false,
        modalView: null,
        isProtectQuiz: false,
      })
    }
  }

  openModal(modalView, index) {
    if (index) {
      window.history.pushState('', '', window.location.origin + window.location.pathname + '#' + index)
    }

    this.setState({
      index: index,
      isModalOpen: true,
      modalView: modalView
    })
  }

  pageLoaded() {
    setTimeout(() => {
      this.temporaryImages = document.querySelector('.temporary-images')

      if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function() {
          if (this.parentNode) {
            this.parentNode.removeChild(this);
          }
        };
      }

      this.temporaryImages.remove()
    }, 1500)

    setTimeout(() => {
      window.dispatchEvent(this.eventUpdateGrid)
    }, 0)

    document.body.classList.add('initialized')

    if (window.location.hash) {
      const fact = window.location.hash.replace('#', '')
      if (fact >= 0 && fact <= FactsData.data.length) {
        this.setState({
          index: fact,
          isPageLoaded: true,
          modalView: 'fact'
        })
      }
    }

    this.setState({
      isPageLoaded: true
    })
  }

  getFactsDataByTag(tag) {
    let partial = false
    const factsDataByTag = FactsData.data.filter(
      function(data) {
        if (tag === 'all') {
          return data
        } else if (tag === 'quiz') {
          partial = true
          return data.quiz
        } else {
          partial = true
          return data.tag === parseInt(tag)
        }
      }
    )

    this.setState({
      currentTag: tag,
      factsData: factsDataByTag,
      isModalOpen: false,
      modalView: null,
      partial: partial
    })

    setTimeout(() => {
      window.dispatchEvent(this.eventUpdateGrid)
    }, 0)
  }

  getWindowSize() {
    let windowWidth = window.innerWidth

    if (windowWidth > 1280) {
      this.setState({
        windowWidth: 1440
      })
    } else if (windowWidth > 1024) {
      this.setState({
        windowWidth: 1280
      })
    } else if (windowWidth > 980) {
      this.setState({
        windowWidth: 1024
      })
    } else if (windowWidth > 768) {
      this.setState({
        windowWidth: 980
      })
    } else if (windowWidth > 425) {
      this.setState({
        windowWidth: 768
      })
    }
  }

  render() {
    return (
      <>
        {
          !this.state.isPageLoaded &&
            <Preloader
              {...this.handlers}
              {...this.state}
            />
        }

        <TagMenu
          {...this.handlers}
          {...this.state}
        />
        <Grid
          {...this.handlers}
          {...this.state}
        />

        {
          this.state.isPageLoaded && this.state.modalView &&
          <Modal
            {...this.handlers}
            modalView={this.state.modalView}
          >
            {
              this.state.modalView === 'default' &&
              <ModalDefault
                {...this.handlers}
                {...this.state}
              />
            }
            {
              this.state.modalView === 'fact' &&
              <ModalFact
                {...this.handlers}
                {...this.state}
                index={this.state.index}
              />
            }
          </Modal>
        }
      </>
    )
  }
}

export default App
